import { Theme } from '@mui/material';
import styled from '@emotion/styled';

import { Link } from "react-router-dom";
import { Box } from '@mui/material';

type ParamsStyle = {
    theme?: Theme;
}

export const Card = styled(Link)(
    ({ theme }: ParamsStyle) => `
        display: grid;
        grid-template-rows: 2.79rem auto;

        &.disabled {
            opacity: .3;
            cursor: not-allowed;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            grid-template-rows: 4.125rem auto;
        }
`);

export const BoxCustom = styled(Box)(
    ({ theme }: ParamsStyle) => `
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #0AA8E3;
        border-radius: 0 0 .75rem .75rem;
        gap: .75rem;
        padding: 0 .45rem;

        p {
            color: white;
            text-align: center;
            font-weight: 600;
            font-size: .75rem;
            line-height: 15px;
        }

        svg {
            display: none;
        }

        @media(min-width: ${theme?.breakpoints.values.md}px) {
            svg {
                display: block;
            }
            p {
                text-align: left;
                font-size: .93rem;
                line-height: 18px;
            }
        }

`);
